window.AbstraxEmulsionAccess = window.AbstraxEmulsionAccess || {};
(function (access) {
  if (access._safeProductJsonWrapped) return;
  var original = access.filterProductJson;
  access.filterProductJson = function (product) {
    try {
      var filtered = typeof original === 'function' ? original.call(access, product) : product;
      if (filtered && filtered.variants && filtered.variants.length) return filtered;
    } catch (err) {}
    return product;
  };
  access._safeProductJsonWrapped = true;
})(window.AbstraxEmulsionAccess);

(function ($) {
  var accordionFirstOpenSelectors = [
    ".collection-faq-wrap .accordion",
    ".pro-specifications .accordion",
    ".sample-aaplication-faq .accordion",
    ".pro-faq-wrap .collection-faq-row .accordion",
    ".faq-section .accordion",
  ];

  function syncAccordionAria($ul) {
    $ul.find("> li > a").each(function () {
      $(this).attr(
        "aria-expanded",
        $(this).parent("li").hasClass("active") ? "true" : "false"
      );
    });
  }

  function openFirstAccordionPanels() {
    for (var i = 0; i < accordionFirstOpenSelectors.length; i++) {
      $(accordionFirstOpenSelectors[i]).each(function () {
        var $ul = $(this);
        var $firstHeader = $ul.find("> li > a").eq(0);
        if (!$firstHeader.length) return;

        var $li = $firstHeader.parent("li");
        var $panel = $li.children("div").first();
        if ($li.hasClass("active") && $panel.length && $panel.is(":visible")) {
          syncAccordionAria($ul);
          return;
        }
        if ($li.hasClass("active")) {
          $panel.show();
          $ul.children("li").not($li).removeClass("active").children("div").hide();
          syncAccordionAria($ul);
          return;
        }
        $firstHeader.trigger("click");
        syncAccordionAria($ul);
      });
    }
  }

  function initAccordions() {
    if (typeof $.fn.accordion !== "function") return;
    $("ul.accordion").accordion();
    openFirstAccordionPanels();
  }

  $(initAccordions);
  $(window).on("load", openFirstAccordionPanels);
  $(document).on("click", "ul.accordion > li > a", function () {
    syncAccordionAria($(this).closest("ul.accordion"));
  });
  $(document).on("keydown", "ul.accordion > li > a", function (e) {
    if (e.which === 32 || e.key === " ") {
      e.preventDefault();
      $(this).trigger("click");
    }
  });

  var trademarkSkip = /^(SUP|SCRIPT|STYLE|TEXTAREA|NOSCRIPT|CODE|KBD|SVG|TITLE)$/;

  function hasTrademarkMark(text) {
    if (!text) return false;
    return (
      text.indexOf("®") !== -1 ||
      text.indexOf("™") !== -1 ||
      text.indexOf("Ⓡ") !== -1 ||
      /(^|[^A-Za-z0-9])TM([^A-Za-z0-9]|$)/.test(text)
    );
  }

  function wrapTrademarkMarks(root) {
    try {
      if (!root) return;
      var scope = root.nodeType === 3 ? root.parentNode : root;
      if (!scope || !scope.ownerDocument) return;
      if (scope.nodeType === 1 && trademarkSkip.test(scope.tagName)) return;

      var walk = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
      var nodes = [];
      var node;
      while ((node = walk.nextNode())) {
        if (!hasTrademarkMark(node.nodeValue)) continue;
        var parent = node.parentElement;
        if (!parent || trademarkSkip.test(parent.tagName)) continue;
        if (parent.closest && parent.closest("sup, script, style, textarea, noscript")) continue;
        nodes.push(node);
      }

      for (var i = 0; i < nodes.length; i++) {
        var textNode = nodes[i];
        if (!textNode.parentNode) continue;
        var fragment = document.createDocumentFragment();
        var parts = textNode.nodeValue.split(/(®|™|Ⓡ|\bTM\b)/);
        for (var j = 0; j < parts.length; j++) {
          var part = parts[j];
          if (part === "®" || part === "™" || part === "Ⓡ" || part === "TM") {
            var sup = document.createElement("sup");
            sup.textContent = part;
            fragment.appendChild(sup);
          } else if (part) {
            fragment.appendChild(document.createTextNode(part));
          }
        }
        textNode.parentNode.replaceChild(fragment, textNode);
      }
    } catch (err) {}
  }

  function observeTrademarkMarks() {
    if (!window.MutationObserver || !document.body) return;
    if (document.body.getAttribute("data-tm-wrap") === "1") return;
    document.body.setAttribute("data-tm-wrap", "1");
    var obs = new MutationObserver(function (mutations) {
      obs.disconnect();
      try {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var el = added[j];
            if (el.nodeType === 3 && el.parentNode) wrapTrademarkMarks(el.parentNode);
            else if (el.nodeType === 1 && el.tagName !== "SUP") wrapTrademarkMarks(el);
          }
        }
      } finally {
        obs.observe(document.body, { childList: true, subtree: true });
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  $(function () {
    wrapTrademarkMarks(document.body);
    observeTrademarkMarks();
  });
  $(window).on("load", function () {
    wrapTrademarkMarks(document.body);
  });

  $(document).ready(function () {
    $(".menu-btn>a").click(function () {
      $("body").addClass("no-scroll");
      $(".mobile-menu").addClass("active");
    });
    $(".menu-close>a").click(function () {
      $("body").removeClass("no-scroll");
      $(".mobile-menu").removeClass("active");
    });

    $(".mobile-menu-link li a").on("click", function () {
      var target = $(this).attr("data-rel");
      $(".mobile-menu-link li a").removeClass("active");
      $(this).addClass("active");
      $("#" + target)
        .fadeIn("slow")
        .siblings(".megamenu")
        .hide();
      return false;
    });

    //.faq-list li a
    $(".faq-list li a").click(function (e) {
      e.preventDefault();

      var href = $(this).attr("href");
      var headerH = $(".header_wrap").innerHeight();
      var headerTH = headerH + 15;
      var scrollTo = $(href).offset().top - headerTH;

      $("html, body").animate(
        {
          scrollTop: scrollTo,
        },
        400
      );
    });

    $(".cart-icon").click(function () {
      // $('body').addClass('no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".hhja").click(function () {
      //   $('body').addClass('no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".close-cart").click(function () {
      $("body").removeClass("no-scroll");
      $(".side-cart").removeClass("active", 250);
    });

    $(".layer14").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 50,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn2").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 340,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".omni-collection-banner-footer .down-btn2, .omni-sample-collection-banner-footer .down-btn2 ").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 120,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".hero-slider").slick({
      dots: true,
      infinite: true,
      arrows: false,
      //fade:true,
      slidesToShow: 1,
      asNavFor: ".ab-industry-nav",
      slidesToScroll: 1,
    });

    $(".ab-industry-nav").slick({
      dots: false,
      infinite: true,
      arrows: false,
      //fade:true,
      asNavFor: ".hero-slider",
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    if ($.fn.layerSlider) {
    $("#slider").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 1600,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 1048,
    });

    $("#slider2").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 375,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 741,
    });
    }

    $(".a-what-new-slide").slick({
      dots: true,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      centerPadding: "370px",
      accesibility: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "0",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "120px",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: "0",
            slidesToScroll: 2,
            accessibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
            infinite: true,
          },
        },
      ],
    });

    $(".custom-slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "222px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "0px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: false,
            arrows: false,
            centerPadding: "60px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".custom-slide2").not(".quantum-collection-row .custom-slide2").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "222px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "0px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: false,
            arrows: false,
            centerPadding: "60px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".quantum-collection-row .custom-slide2").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: false,
        //     centerPadding: '30px',
        //     slidesToScroll: 3
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 2,
            initialSlide: 0,
          },
        },
      ],
    });

    $(".quantum-collection-row .sample-kit-slider").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 2500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 1,
            initialSlide: 0,
          },
        },
      ],
    });


    $(".quantum-collection-row .custom-slide3").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            //  slidesToShow: 3,
            //  slidesToScroll: 3,
            //  centerMode: true,
            // centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
            centerPadding: "125px",
            slidesToScroll: 1,
          },
        },
      ],
    });


    //       $('.custom-arrow .prevb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-prev').trigger('click');
    // });


    // $('.custom-arrow .nextb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-next').trigger('click');
    // });


    // if ($(window).width() > 768) {
    //   $(".other-pro-head .nextb").trigger("click");
    // }
  });

  $(".footer-link h3").click(function () {
    $(this).toggleClass("active", 500);
    $(this).next(".show-m").toggle(500);
  });

  $(".h-blog-slide").slick({
    dots: true,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: true,
    prevArrow: $(".prevb"),
    nextArrow: $(".nextb"),
    centerPadding: "300px",
    responsive: [
      {
        breakpoint: 1602,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
          centerPadding: "215px",
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          arrows: false,
          centerPadding: "10px",
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).ready(function () {
    $(".h-blog-slides").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 2,
      centerMode: true,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1602,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: "215px",
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            centerPadding: "150px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "50px",
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: false,
            arrows: false,
            centerPadding: "36px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".categories_slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      // prevArrow: $('.prev'),
      // nextArrow: $('.next'),
      prevArrow:
        "<button type='button' class='prev '><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
      nextArrow:
        "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "80px",
          },
        },
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $(".single-blog .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".single-case-studies .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });
  $(".single-media .img").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".article-template-banner").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  jQuery(".video")
    .parent()
    .click(function () {
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play();
        $(this).children(".playpause").fadeOut();
      } else {
        $(this).children(".video").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
    });

  $(document).on('click', '.qty-flex .qty', function (t) {
    // Slide-cart owns its own +/- handler (AJAX /cart/change.js).
    // Running both increments/decrements by 2 per click.
    if ($(this).closest('.side-cart').length) return;

    var $button = $(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.hasClass("qty-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().parent().find("input").val(newVal);
  });

  const createSVG = (width, height, radius) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    const rectangle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );

    svg.setAttributeNS(
      "http://www.w3.org/2000/svg",
      "viewBox",
      `0 0 ${width} ${height}`
    );

    rectangle.setAttribute("x", "0");
    rectangle.setAttribute("y", "0");
    rectangle.setAttribute("width", "100%");
    rectangle.setAttribute("height", "100%");
    rectangle.setAttribute("rx", `${radius}`);
    rectangle.setAttribute("ry", `${radius}`);
    rectangle.setAttribute("pathLength", "10");

    svg.appendChild(rectangle);

    return svg;
  };

  function btnPrimaryIsBlocked(button) {
    return (
      button.getAttribute("aria-disabled") === "true" ||
      button.classList.contains("sample-allowance-checkout-blocked") ||
      button.classList.contains("emulsion-access-checkout-blocked")
    );
  }

  function enhanceBtnPrimary(button) {
    if (!button || button.querySelector(".lines")) return;

    const style = getComputedStyle(button);

    const lines = document.createElement("div");

    lines.classList.add("lines");

    const groupTop = document.createElement("div");
    const groupBottom = document.createElement("div");

    const svg = createSVG(
      button.offsetWidth,
      button.offsetHeight,
      parseInt(style.borderRadius, 10)
    );

    groupTop.appendChild(svg);
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));

    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));

    lines.appendChild(groupTop);
    lines.appendChild(groupBottom);

    button.appendChild(lines);

    button.addEventListener("pointerenter", () => {
      if (btnPrimaryIsBlocked(button)) return;
      button.classList.add("start");
    });

    svg.addEventListener("animationend", () => {
      button.classList.remove("start");
    });
  }

  function enhanceBtnPrimaryButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".btn-primary").forEach(enhanceBtnPrimary);
  }

  enhanceBtnPrimaryButtons();
  document.addEventListener("cart:updated", function () {
    enhanceBtnPrimaryButtons(document.querySelector(".side-cart") || document);
  });

  $(".product-slide").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='prev'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
    nextArrow:
      "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
  });

  $(document).on("scroll", function () {
    var featHeight = $(".ab-product-wrap").height();
    setTimeout(function () {
      if ($(document).scrollTop() > featHeight) {
        $(".sticky_cart").addClass("fixed");
      } else {
        $(".sticky_cart").removeClass("fixed");
      }
    }, 300);
  });

  $(document).on("change", ".swatch :radio", function () {
    var $swatch = $(this).closest(".swatch");
    var value = $(this).val();
    var label =
      window.AbstraxSwatches && AbstraxSwatches.formatOptionLabel
        ? AbstraxSwatches.formatOptionLabel(value)
        : value;
    $swatch.find(".select-dropdown__button > span").first().html(label);
    $swatch.find(".select-dropdown__button").attr("data-value", value);
  });

  //  $(".blal ").click(function() {
  //   $(this).closest('.select-dropdown').find('.select-dropdown__button span').text($(this).text());
  // });
  $(document).ready(function () {
    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        $(".swatch ").removeClass("active");
        $(".select-dropdown__button").attr("aria-expanded", "false");
        $("body").removeClass("activew");
        $(".Collapsible .collapse-headers").removeClass("active");
        $(".Collapsible").removeClass("active");
      }
    });
  });
  $(document).mouseup(function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.closest(".Collapsible")) {
      $(".Collapsible .collapse-headers").removeClass("active");
      $(".Collapsible").removeClass("active");
    }
  });




  $(".toggle").click(function () {
    $(".product2-right").toggleClass("active");
  });

  //     $(document).on('click', '.collapse-headers', function(){
  //   $(this).toggleClass('active');
  //   $(this).next('.collapse-items').toggleClass('show');
  // });

  $("body").on(
    "click",
    ".collection-filters-form .Collapsible .collapse-headers, .collection-filters-form .Collapsible .collapse-headers *",
    function () {
      var $header = $(this).closest(".collapse-headers");
      var $col = $(this).closest(".Collapsible");
      if (!$header.length || !$col.length) return;
      if ($header.hasClass("quick-order-sold-out")) return;
      if ($header.hasClass("quick-order-emulsion-locked")) return;
      $header.toggleClass("active");
      $col.toggleClass("active");
      $col.siblings().removeClass("active");
    }
  );
  //   $('.Collapsible .collapse-headers').click(function(event){
  //    event.stopPropagation();
  // });
  //       $('body').click(function() {
  //    $('.Collapsible .collapse-headers').removeClass("active");
  //         $('.Collapsible').removeClass("active");
  // });

  //   $('input#Search-In-Modal-1').keyup(function() {
  //      if($(this).val().length > 1) {
  //         $('body').addClass("width-100");

  //     } else {
  //        $('body').removeClass("width-100");
  //     }
  // });
  $(".search-icon").click(function () {
    $(".desk-search_wrap").addClass("active"),
      setTimeout(function () {
        
        $("#goal-input").focus();
        $(".Search__Input").focus();
      }, 500);
       
    $('body').addClass('no-scroll');
    }),
      
    $('.search-i').click(function(){
    $('.desk-search_wrap').removeClass('active');
    $('body').removeClass('no-scroll');
      $('.header__search details').removeAttr("open");
      $('input[type="search"]').val('');
      $('.Search__Results').attr('aria-hidden', 'true'); // hide results
    })

 //$('.modal__close-button').click(function(){
   // $('body').removeClass("width-100");
    //$('input.search__input[type="search"]').val('');
    //$(".search-modal__form").removeAttr("open");
  //});

  $(window).scroll(function () {
    var sticky = $(".header_wrap"),
      scroll = $(window).scrollTop();

    if (scroll >= 50) sticky.addClass("fixed");
    else sticky.removeClass("fixed");
  });

  $(".mobile-show-f .link").click(function () {
    $(".faq-list").toggleClass("more", 500);
    if ($(".mobile-show-f .link").text() == "MORE FILTERS") {
      $(this).text("CLOSE FILTERS");
    } else {
      $(this).text("MORE FILTERS");
    }
  });

  $("a.link.read-bio").click(function () {
    $(this).parents(".meet-team-row").addClass("show-bio");
  });
  $(".link.hide-bio ").click(function () {
    $(this).parents(".meet-team-row").removeClass("show-bio");
  });

  $(".add_to_cart_buttona").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".add_to_cart_buttona").removeClass("active");
    }, 250);
  });
  $(".btn").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".btn").removeClass("active");
    }, 400);
  });

  // $(document).ready(function(){
  //       $(".accordion-titel").click(function(){
  //       $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
  //       $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
  //       $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
  //       });
  //   });

  //   $(document).ready(function() {
  // 	$('.accordion-item').on('click', '.accordion-titel', function() {
  // 		$('.accordion-contant').slideUp().removeClass('flipInX');
  // 		$('.accordion-titel').removeClass('fa-minus');
  // 		if($(this).next().is(':hidden')) {
  // 			$(this).next().slideDown().addClass('flipInX');
  // 			$(this).find('.accordion-titel').addClass('fa-minus');
  // 		} else {
  // 			$(this).next().slideUp();
  // 			$(this).find('.accordion-titel').addClass('fa-plus');
  // 		}
  // 	});
  // });

  $(".accordion-item").on("click", ".accordion-titel", function () {
    $(".accordion-contant").slideUp();

    if ($(this).hasClass("active")) {
      $(this).next().slideUp();
      $(this).removeClass("active");
    } else {
      $(this).next().slideDown();
      $(".accordion-titel").removeClass("active");
      $(this).addClass("active");
    }
  });

  // $(document).ready(function() {
  //   $.fancybox.open({
  //   type: "inline",
  //   touch: false
  // });
  //});

  $(".open-pop").magnificPopup({
    type: "inline",
    fixedContentPos: true,
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  $(document).ready(function () {
    $(".f-button").click(function () {
      $.magnificPopup.close();
    });
  });
  //   jQuery('#sign-up').fancybox({
  //     mobile: {
  //            clickSlide: false,
  //             touch: false
  //         },
  // });
  //  $(':button').click(function() {
  //     parent.$.fancybox.close();
  // })
})(jQuery);

$(document).ready(function () {
  // Attach a click event handler to the select element within the specific .item
  $(".item .select-wrp select").on("change", function () {
    // Get the selected value from the select element
    var selectedValue = $(this).val();

    // Find the parent .item and then find retail_prices within that specific item
    var retailPrices = $(this).closest(".item").find(".retail_prices");

    // Hide all h5 elements under retail_prices within the specific item
    retailPrices.find("div").hide();

    // Show the specific h5 element based on the selected value within the specific item
    retailPrices.find('div[value="' + selectedValue + '"]').show();
  });
});




document.addEventListener('DOMContentLoaded', function () {
  console.log("STICKY CART LISTENER ACTIVE");
  const announcementBar = document.querySelector('.announcement-bar');
  const stickyCart = document.querySelector('.sticky_cart');

  if (announcementBar && stickyCart) {
    stickyCart.classList.add('has-announcement');
  }
});



document.addEventListener('click', function (e) {
  if (e.target.matches('[data-action="select-value"]')) {
    e.preventDefault();

    // Remove is-selected class from any previously selected items
    document.querySelectorAll('[data-action="select-value"]').forEach(el => {
      el.classList.remove('is-selected');
    });

    // Add is-selected class to clicked element
    e.target.classList.add('is-selected');

    const sortValue = e.target.getAttribute('data-value');
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortValue);

    // Update URL without reload
    window.history.pushState({}, '', currentUrl.toString());

    // Show loading state
    const productGrid = document.querySelector('.ProductList');
    if (productGrid) {
      productGrid.style.opacity = '0.5';
    }

    // Fetch new content
    fetch(currentUrl.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Get the new product grid
        const newProductGrid = doc.querySelector('.ProductList');

        if (newProductGrid && productGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
          productGrid.style.opacity = '1';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Fallback to page reload if fetch fails
        window.location.href = currentUrl.toString();
      });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  let isActive = false;
  /** Used to ignore spurious mobile `resize` (URL bar show/hide on scroll) where only height changes. */
  var lastFilterLayoutWidth = window.innerWidth;

  function getCollapsibleElements() {
    return document.querySelectorAll(
      '.Collapsible.Collapsible--padded.Collapsible--autoExpand:not(.natural-ingredients), .sortconeasher.Collapsiblea'
    );
  }

  function isMobile() {
    return window.innerWidth < 615;
  }

  function syncFilterQuickButtonState() {
    document.querySelectorAll('.filter-quick a').forEach(function(button) {
      button.classList.toggle('active', isActive);
    });
  }

  // forceClose: true on AJAX reload (always reset); false on resize (preserve open state)
  function setInitialState(forceClose) {
    var collapsibleElements = getCollapsibleElements();
    if (isMobile()) {
      if (forceClose) {
        isActive = false;
      }
      collapsibleElements.forEach(element => {
        if (isActive) {
          element.style.display = 'block';
          element.style.visibility = 'visible';
          element.style.opacity = '1';
          element.style.overflow = 'visible';
          element.style.height = 'auto';
        } else {
          element.style.display = 'none';
          element.style.height = '0px';
          element.style.opacity = '0';
          element.style.overflow = 'hidden';
          element.style.visibility = 'hidden';
        }
      });
    } else {
      isActive = false;
      collapsibleElements.forEach(element => {
        element.style.display = '';
        element.style.height = '';
        element.style.opacity = '';
        element.style.overflow = '';
        element.style.visibility = '';
      });
    }

    syncFilterQuickButtonState();
  }

  setInitialState(true);

  // Width-only guard plus debounce: iOS fires resize as the address bar slides
  // during scroll. Height-only changes are ignored; width changes wait 200ms.
  var resizeTimer;
  window.addEventListener('resize', function () {
    var w = window.innerWidth;
    if (w === lastFilterLayoutWidth) return;
    lastFilterLayoutWidth = w;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { setInitialState(false); }, 200);
  });

  document.addEventListener('click', function (e) {
    var filterQuickBtn = e.target.closest('.filter-quick a');
    if (!filterQuickBtn) return;
    if (!isMobile()) return;

    e.preventDefault();
    e.stopPropagation();
    isActive = !isActive;
    syncFilterQuickButtonState();

    var collapsibleElements = getCollapsibleElements();
    collapsibleElements.forEach(element => {
      if (isActive) {
        element.style.display = 'block';
        element.style.visibility = 'visible';
        element.style.transition = 'none';
        element.style.height = '0px';
        element.offsetHeight;

        element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
        element.style.height = `${element.scrollHeight}px`;
        element.style.opacity = '1';

        element.addEventListener('transitionend', function handler() {
          if (isActive) {
            element.style.height = 'auto';
            element.style.overflow = 'visible';
          }
          element.removeEventListener('transitionend', handler);
        }, { once: true });
      } else {
        element.style.overflow = 'hidden';
        element.style.height = `${element.scrollHeight}px`;
        element.offsetHeight;

        element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
        element.style.height = '0px';
        element.style.opacity = '0';

        element.addEventListener('transitionend', function handler() {
          if (!isActive) {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
          }
          element.removeEventListener('transitionend', handler);
        }, { once: true });
      }
    });
  });

  document.addEventListener('theme:loading:end', function () {
    isActive = false;
    setInitialState(true);
    if (isMobile()) {
      var badges = document.querySelectorAll('.tooltips.flavor-type-badge');
      badges.forEach(function (b) { b.style.pointerEvents = 'none'; });
      setTimeout(function () {
        badges.forEach(function (b) { b.style.pointerEvents = ''; });
      }, 500);
    }
  });
});


// QUICK ORDER STUFFS

function quickOrderHasActiveFilters() {
  try {
    var params = new URLSearchParams(window.location.search);
    var found = false;
    params.forEach(function (_, key) {
      if (key.indexOf('filter.') === 0) found = true;
    });
    return found;
  } catch (e) {
    return false;
  }
}

function resetQuickOrderSearchResults() {
  $('.maindef .qucik-order-list-row').show();
  $('.maindef').show();
  $('#Search__Results_quick').hide();
  $('div#AjaxinatePagination').show();
  $('div#AjaxinatePaginationa').hide();
  var oaa = $('body').find('.reapro').html();
  $('.quick-btn h2').html(oaa).removeClass('quick-search-empty');
}

function applyQuickOrderClientSearch(query) {
  var q = (query || '').toLowerCase().trim();
  var matchCount = 0;
  $('.maindef .qucik-order-list-row').each(function () {
    var hay = (this.getAttribute('data-search-text') || this.textContent || '').toLowerCase();
    var match = hay.indexOf(q) > -1;
    $(this).toggle(match);
    if (match) matchCount += 1;
  });
  $('.maindef').show();
  $('#Search__Results_quick').hide();
  $('div#AjaxinatePaginationa').hide();
  $('div#AjaxinatePagination').show();
  var $title = $('.quick-btn h2');
  $title.html(matchCount === 0 ? 'No products found' : matchCount + ' Products');
  $title.toggleClass('quick-search-empty', matchCount === 0);
}

function runQuickOrderSearch(query) {
  if (!query || query.length < 2) {
    resetQuickOrderSearchResults();
    return;
  }

  if (quickOrderHasActiveFilters()) {
    applyQuickOrderClientSearch(query);
    return;
  }

  $.ajax({
    type: 'GET',
    url: '/search?section_id=quick_search&q=' + encodeURIComponent(query) + '&type=product&options[prefix]=last',
    success: function(data) {
      $(document).mouseup(function(e)
      {
        var container = $(".Collapsible");

        if (!e.target.closest || !e.target.closest(".Collapsible"))
        {
          $('.Collapsible').removeClass('active');
          $('.collapse-headers').removeClass("active");
          $('body').removeClass("activew");
        }
      });

      $('#Search__Results_quick').html(data);

      var ea = $(data);
      var ia = $("<div>").append(ea);
      var oa = ia.find(".searcount").html();
      var quickSearchCount = parseInt(oa, 10);
      if (isNaN(quickSearchCount)) quickSearchCount = 0;
      var $quickBtnTitle = $(".quick-btn h2");
      $quickBtnTitle.html(
        quickSearchCount === 0 ? "No products found" : quickSearchCount + " Products"
      );
      $quickBtnTitle.toggleClass("quick-search-empty", quickSearchCount === 0);
      $('.maindef').hide();
      $('div#AjaxinatePagination').hide();
      $('#Search__Results_quick').show();
      $('div#AjaxinatePaginationa').show();
      const createSVG = (width, height, radius) => {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

        const rectangle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "rect"
        );

        svg.setAttributeNS(
          "http://www.w3.org/2000/svg",
          "viewBox",
          `0 0 ${width} ${height}`
        );

        rectangle.setAttribute("x", "0");
        rectangle.setAttribute("y", "0");
        rectangle.setAttribute("width", "100%");
        rectangle.setAttribute("height", "100%");
        rectangle.setAttribute("rx", `${radius}`);
        rectangle.setAttribute("ry", `${radius}`);
        rectangle.setAttribute("pathLength", "10");

        svg.appendChild(rectangle);

        return svg;
      };

      document.querySelectorAll("#Search__Results_quick .btn-primary").forEach((button) => {
        const style = getComputedStyle(button);

        const lines = document.createElement("div");

        lines.classList.add("lines");

        const groupTop = document.createElement("div");
        const groupBottom = document.createElement("div");

        const svg = createSVG(
          button.offsetWidth,
          button.offsetHeight,
          parseInt(style.borderRadius, 10)
        );

        groupTop.appendChild(svg);
        groupTop.appendChild(svg.cloneNode(true));
        groupTop.appendChild(svg.cloneNode(true));
        groupTop.appendChild(svg.cloneNode(true));

        groupBottom.appendChild(svg.cloneNode(true));
        groupBottom.appendChild(svg.cloneNode(true));
        groupBottom.appendChild(svg.cloneNode(true));
        groupBottom.appendChild(svg.cloneNode(true));

        lines.appendChild(groupTop);
        lines.appendChild(groupBottom);

        button.appendChild(lines);

        button.addEventListener("pointerenter", () => {
          button.classList.add("start");
        });

        svg.addEventListener("animationend", () => {
          button.classList.remove("start");
        });
      });
      $('.bakctotop').on("click",function(){
        $(window).scrollTop(0);
      });
    }
  });
}

$(document).on('keyup', '.qucik-order-search input[name="q"]', function(){
  runQuickOrderSearch($(this).val());
});

$(document).on('click', '.qucik-order-search .close-c', function() {
  var $wrap = $(this).closest('.qucik-order-search');
  var $qInput = $wrap.find('input[name="q"]');
  var inputEl = $qInput[0];
  if (inputEl) {
    inputEl.value = '';
    inputEl.dispatchEvent(new Event('input', { bubbles: true }));
  }
  resetQuickOrderSearchResults();
});

$(document).mouseup(function(e) {
  var $input = $('.qucik-order-search input[name="q"]');
  if (!$input.length) return;
  if (e.target.closest && e.target.closest(".qucik-order-search")) return;
  $('body').removeClass('activew');
});

$(document).on('focusout', '.qucik-order-search input[name="q"]', function(){
  if($(this).val().length === 0){
    resetQuickOrderSearchResults();
  }
});

document.addEventListener('quickorder:products:appended', function () {
  var input = document.querySelector('.qucik-order-search input[name="q"]');
  if (!input || !quickOrderHasActiveFilters()) return;
  if ((input.value || '').length > 1) {
    applyQuickOrderClientSearch(input.value);
  }
});


$( document ).ready(function() {
  $(".mobveafromhere").detach().appendTo('.dttachagai');
  
});

(function () {
  function closest(el, selector) {
    if (!el || !el.closest) return null;
    return el.closest(selector);
  }

  function formatOptionLabel(value) {
    var raw = String(value || "");
    var n = raw.toLowerCase().replace(/\s+/g, "");
    if (
      n === "5g|5ml" ||
      n === "5g/5ml" ||
      n === "5g/5.8ml" ||
      n === "5g|5.8ml"
    ) {
      if (raw.indexOf(" - Sample") === -1) return raw + " - Sample";
    }
    return raw;
  }

  function refreshSwatchLabels(root) {
    var swatches = (root || document).querySelectorAll(".swatch[data-option-index]");
    var i;
    var swatch;
    var radio;
    var label;
    var button;
    for (i = 0; i < swatches.length; i++) {
      swatch = swatches[i];
      radio = swatch.querySelector("input[type='radio']:checked");
      label = swatch.querySelector(".select-dropdown__button > span");
      button = swatch.querySelector(".select-dropdown__button");
      if (!radio || !label) continue;
      label.textContent = formatOptionLabel(radio.value);
      if (button) button.setAttribute("data-value", radio.value);
    }
  }

  function setSelectId(select, id) {
    if (!select || !id) return false;
    var want = String(id);
    select.value = want;
    if (select.value === want) return true;
    var i;
    for (i = 0; i < select.options.length; i++) {
      if (String(select.options[i].value) === want) {
        select.selectedIndex = i;
        return true;
      }
    }
    return false;
  }

  function setOptionSelectValue(select, value) {
    if (!select || value == null) return;
    select.value = value;
    if (select.value === value) return;
    var want = String(value).toLowerCase().replace(/\s+emulsion$/, "").trim();
    var i;
    var raw;
    for (i = 0; i < select.options.length; i++) {
      raw = String(select.options[i].value || "")
        .toLowerCase()
        .replace(/\s+emulsion$/, "")
        .trim();
      if (raw === want) {
        select.selectedIndex = i;
        return;
      }
    }
  }

  function readVariantPrices() {
    if (readVariantPrices.cache) return readVariantPrices.cache;
    var el = document.getElementById("SwatchVariantPrices");
    readVariantPrices.cache = { format: "${{amount}}", variants: {} };
    if (!el) return readVariantPrices.cache;
    try {
      var parsed = JSON.parse(el.textContent);
      if (parsed && parsed.variants) {
        readVariantPrices.cache = parsed;
      } else if (parsed) {
        readVariantPrices.cache = { format: "${{amount}}", variants: parsed };
      }
    } catch (err) {}
    return readVariantPrices.cache;
  }

  function updateProductPrice(variantId) {
    if (!variantId) return;
    var data = readVariantPrices();
    var info = data.variants && data.variants[String(variantId)];
    if (!info) return;
    if (window.timber && typeof timber.productPage === "function") {
      timber.productPage({
        money_format: data.format || "${{amount}}",
        variant: {
          id: variantId,
          price: info.cents,
          compare_at_price: info.compare_cents || 0,
          available: true,
        },
      });
    }
    var priceEl = document.getElementById("ProductPrice");
    if (priceEl && info.money) priceEl.innerHTML = info.money;
    var compareEl = document.getElementById("ComparePrice");
    if (compareEl) {
      if (info.compare_money) {
        compareEl.innerHTML = info.compare_money;
        compareEl.style.display = "";
      } else {
        compareEl.style.display = "none";
      }
    }
  }

  function resolveVariantId(root) {
    var checked = (root || document).querySelectorAll(
      ".swatch input[type='radio']:checked"
    );
    var intersection = null;
    var i;
    var j;
    var ids;
    var next;
    for (i = 0; i < checked.length; i++) {
      ids = String(checked[i].getAttribute("data-variant-ids") || "")
        .split(",")
        .filter(Boolean);
      if (!ids.length) continue;
      if (intersection === null) {
        intersection = ids;
      } else {
        next = [];
        for (j = 0; j < intersection.length; j++) {
          if (ids.indexOf(intersection[j]) !== -1) next.push(intersection[j]);
        }
        intersection = next;
      }
    }
    if (!intersection || !intersection.length) return null;
    var master = document.getElementById("productSelect");
    var current = master ? String(master.value) : "";
    if (current && intersection.indexOf(current) !== -1) return current;
    return intersection[0];
  }

  function applySwatchVariant(root) {
    if (applySwatchVariant.busy) return null;
    applySwatchVariant.busy = true;
    try {
      var form =
        (root && root.querySelector ? root : null) ||
        document.getElementById("AddToCartForm") ||
        document;
      var variantId = resolveVariantId(form);
      if (!variantId) return null;

      var i;
      var selectors = form.querySelectorAll
        ? form.querySelectorAll(".single-option-selector")
        : [];
      var swatches = form.querySelectorAll
        ? form.querySelectorAll(".swatch[data-option-index]")
        : [];
      var swatch;
      var radio;
      var optionIndex;
      var select;
      for (i = 0; i < swatches.length; i++) {
        swatch = swatches[i];
        radio = swatch.querySelector("input[type='radio']:checked");
        if (!radio) continue;
        optionIndex = swatch.getAttribute("data-option-index");
        select =
          form.querySelector("#productSelect-option-" + optionIndex) ||
          selectors[optionIndex];
        if (select) setOptionSelectValue(select, radio.value);
      }

      var master =
        document.getElementById("productSelect") ||
        (form.querySelector && form.querySelector('select[name="id"]'));
      var sticky = document.querySelector(".sticky_cart select[name='id']");
      setSelectId(master, variantId);
      setSelectId(sticky, variantId);

      if (window.jQuery && selectors.length) {
        jQuery(selectors[selectors.length - 1]).trigger("change");
        setSelectId(master, variantId);
        setSelectId(sticky, variantId);
      }
      if (window.jQuery && master) jQuery(master).trigger("change");
      updateProductPrice(variantId);
      refreshSwatchLabels(form);
      try {
        document.dispatchEvent(
          new CustomEvent("abstrax:variantchange", { detail: { id: variantId } })
        );
      } catch (err) {}
      return variantId;
    } finally {
      applySwatchVariant.busy = false;
    }
  }

  window.AbstraxSwatches = {
    applyFromRadios: applySwatchVariant,
    formatOptionLabel: formatOptionLabel,
    refreshLabels: refreshSwatchLabels,
  };

  function scheduleLabelRefresh() {
    setTimeout(refreshSwatchLabels, 0);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleLabelRefresh);
  } else {
    scheduleLabelRefresh();
  }
  window.addEventListener("load", scheduleLabelRefresh);
  document.addEventListener("change", function (event) {
    var target = event.target;
    if (!target) return;
    if (
      target.id === "productSelect" ||
      (target.classList && target.classList.contains("single-option-selector"))
    ) {
      scheduleLabelRefresh();
    }
  });

  function closeSwatches() {
    var open = document.querySelectorAll(".swatch.active");
    var i;
    for (i = 0; i < open.length; i++) {
      open[i].classList.remove("active");
      var btn = open[i].querySelector(".select-dropdown__button");
      if (btn) btn.setAttribute("aria-expanded", "false");
    }
    document.body.classList.remove("activew");
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    var button = closest(target, ".product2-des .select-dropdown__button");
    if (button) {
      event.preventDefault();
      var swatch = closest(button, ".swatch");
      if (!swatch) return;
      var willOpen = !swatch.classList.contains("active");
      closeSwatches();
      if (willOpen) {
        swatch.classList.add("active");
        button.setAttribute("aria-expanded", "true");
        document.body.classList.add("activew");
      }
      return;
    }

    var option = closest(target, ".blal");
    if (option) {
      var value = option.getAttribute("data-value");
      var dropdown = closest(option, ".select-dropdown-pro");
      var radio = option.htmlFor
        ? document.getElementById(option.htmlFor)
        : option.querySelector('input[type="radio"]');
      if (radio) {
        radio.disabled = false;
        radio.checked = true;
        applySwatchVariant(
          radio.closest("form") || document.getElementById("AddToCartForm")
        );
      }
      if (dropdown && value) {
        var label = dropdown.querySelector(".select-dropdown__button > span");
        var display = option.getAttribute("data-label") || formatOptionLabel(value);
        if (label) label.textContent = display;
        var optionBtn = dropdown.querySelector(".select-dropdown__button");
        if (optionBtn) {
          optionBtn.setAttribute("aria-expanded", "false");
          optionBtn.setAttribute("data-value", value);
        }
      }
      closeSwatches();
      return;
    }

    if (!closest(target, ".swatch, .select-dropdown-pro")) {
      closeSwatches();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeSwatches();
  });
})();